import { useForm } from "react-hook-form";
import { Download } from "lucide-react";

import GrayButton from "../../../components/UI/buttonUI/GrayButton";
import DownloadTemplate from "../../../components/common/DownloadTemplate";
import {
  UPDATE_BULK_SALARIES_TEMPLATE,
  UPDATE_SALARIES,
} from "../apiEndpoints";
import UploadFileInput from "../../../components/UI/PageInput/UploadFileInput";
import PrimaryButton from "../../../components/UI/buttonUI/PrimaryButton";
import BulkSalarySuccessDialog from "../dialogs/BulkSalarySuccessDialog";
import MainPageLayout from "../../../layout/MainPageLayout";
import CenteredHeading from "../../../components/UI/headingsUI/CenteredHeading";
import useUploadSheet from "../../../CustomHooks/useAxios/useUploadSheet";
import ErrorDisplay from "../../../components/UI/ErrorDisplay";

const UpdateSalariesPage = () => {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      sheet: undefined,
    },
  });
  const {
    executePost,
    loading,
    isSucceed,
    formError,
    formErrMsg,
    responseData,
    setFormError,
  } = useUploadSheet();
  const sheet = watch("sheet");

  const onSubmit = async (data) => {
    // send data into form data
    const formData = new FormData();
    formData.append("sheet", data.sheet[0]);
    //API calling
    executePost(formData, UPDATE_SALARIES, reset);
  };

  return (
    <MainPageLayout headerConfig={{ title: "Update Bulk Site" }}>
      <div className="form-container">
        <CenteredHeading title="Update Users Salaries" />
        {formError && (
          <ErrorDisplay
            message={formErrMsg}
            closeAction={() => setFormError(false)}
          />
        )}
        <div className="form-border max-w-5xl mx-auto w-95% form-border">
          <div className="flex justify-between">
            <p className="text-gray-500 max-lg:text-sm">
              {sheet && sheet[0]?.name ? "Uploaded" : "Upload"} File
            </p>
            <DownloadTemplate
              apiEndPoint={UPDATE_BULK_SALARIES_TEMPLATE}
              downloadFileName="bulk_update_user_salary"
            />
          </div>
          <form
            onSubmit={!loading ? (e) => handleSubmit(onSubmit)(e) : undefined}
          >
            <UploadFileInput
              name="sheet"
              placeholder=".xlsx"
              accept=".xlsx, file/xlsx"
              register={{
                ...register("sheet", {
                  required: "Please choose a file",
                }),
              }}
              setValue={setValue}
              multiple={true}
              error={errors.sheet}
              uploadedFile={sheet}
              removeUploadedFile={() => setValue("sheet", "")}
            />
            <div className="sheet-upload-btn-wrap">
              <PrimaryButton
                btnText={!loading ? "Upload Sheet" : "Adding..."}
                loading={loading}
                Icon={Download}
                size={20}
              />
              <GrayButton
                btnText="Clear"
                width="w-40"
                onClick={() => reset()}
              />
            </div>
          </form>
          {isSucceed && <BulkSalarySuccessDialog viewDetails={responseData} />}
        </div>
      </div>
    </MainPageLayout>
  );
};

export default UpdateSalariesPage;
